import { formatDistanceToNow } from "date-fns";

export function getTimeAgo(utcIso) {
  let result = formatDistanceToNow(new Date(utcIso), { addSuffix: true });
  result = result.replace(/^about /, '');
  if (/less than a minute/.test(result)) result = 'now';
  return result;
}